import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class RebatesIncomesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RebatesIncomesError', ...args);
    }
}
export default RebatesIncomesError;
